/********************************************************************************
 * Copyright (c) 2024 EclipseSource and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0 WITH Classpath-exception-2.0
 ********************************************************************************/
import { EditLabelAction, EditLabelActionHandler, FeatureModule, TYPES, configureActionHandler } from '@eclipse-glsp/sprotty';
import { GlspEditLabelUI } from './label-edit-ui';

export const labelEditUiModule = new FeatureModule(
    (bind, unbind, isBound, rebind, ...rest) => {
        const context = { bind, unbind, isBound, rebind };
        configureActionHandler(context, EditLabelAction.KIND, EditLabelActionHandler);
        bind(GlspEditLabelUI).toSelf().inSingletonScope();
        bind(TYPES.IUIExtension).toService(GlspEditLabelUI);
    },
    { featureId: Symbol('labelEditUi') }
);
